export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-map-960-10182d694fe3465edafd1ee6848b980d.png";